import { DisplayConfigurationV2 } from "@src/types/DiamondDetail";
import { ProductCategory } from "@utils/constants";

export type JewelryConfiguratorComponentsProps = {
  displayConfigurationV2: DisplayConfigurationV2[];
  productType: ProductCategory;
  maxWidth: number;
  fromReviewPage?: boolean;
  fromOrderCart?: boolean;
  fromRequest?: boolean;
  enterSecondFlow?: boolean;
  updateJewelryConfigInfo?: any;
  onDropdownSelect?: (
    initialValue: string,
    currentValue: string,
    commitFn?: () => void,
    revertFn?: () => void
  ) => void;
};

export enum ButtonStyle {
  SMALL = "compact",
  MEDIUM_01 = "labeled",
  MEDIUM_02 = "labeled_2_line",
  DYNAMIC = "dynamic",
  WITH_PRICE = "with_price",
  TWO_LINE = "2_line",
  DEFAULT = "default",
  RADIO = "radio",
  MEASUREMENT = "measurement",
  RANGE = "range",
}

export type JCSelectedOption = {
  option_slug: { [key: string]: string };
  option_value: { [key: string]: any };
  option_required: { [key: string]: boolean };
  option_searchable: { [key: string]: string };
  option_mode: { [key: string]: string };
  option_visible: [];
  option_error: { [key: string]: string };
};

export type Personalization = {
  engrave_font: string;
  engrave_text: string;
  reference_po: string;
  special_instructions: string;
};

export enum OptionStyle {
  squareIconButtonWithSlider = "square_icon_button_with_slider",
  slider = "slider",
  rectangularTextButton = "rectangular_text_button",
  squareIconButton = "square_icon_button",
  dropDown = "drop_down",
  dropDownSelect = "drop_down_select",
  roundTextButton = "round_text_button",
  rectangularTextButtonWithPrice = "rectangular_text_button_with_price",
  bgSquareIconButton = "bg_square_icon_button",
  squareIconButtonWithBG = "square_icon_button_with_bg",
  mediaButtonLabeledNoCarousel = "media_button-labeled-no_carousel",
  mediaButtonCompactNoCarousel = "media_button-compact-no_carousel",
  mediaButtonLabeled2LineNoCarousel = "media_button-labeled_2_line-no_carousel",
  mediaButtonCompactWithCarousel = "media_button-compact-with_carousel",
  mediaButtonLabeledWithCarousel = "media_button-labeled-with_carousel",
  mediaButtonLabeled2LineWithCarousel = "media_button-labeled_2_line-with_carousel",
  textButtonDynamicNoCarousel = "text_button-dynamic-no_carousel",
  textButton2LineNoCarousel = "text_button-2_line-no_carousel",
  textButtonWithPriceNoCarousel = "text_button-with_price-no_carousel",
  textButtonDynamicWithCarousel = "text_button-dynamic-with_carousel",
  textButton2LineWithCarousel = "text_button-2_line-with_carousel",
  textButtonWithPriceWithCarousel = "text_button-with_price-with_carousel",
  checkBoxButtonDefaultNoCarousel = "checkbox_button-default-no_carousel",
  checkBoxButtonRadioNoCarousel = "checkbox_button-radio-no_carousel",
  dropdownDefaultNoCarousel = "dropdown-default-no_carousel",
  inputFieldMeasurementNoCarousel = "input_filed-measurement-no_carousel",
  inputFieldRangeNoCarousel = "input_filed-range-no_carousel",
  inputFieldDefaultNoCarousel = "input_filed-default-no_carousel",
  sliderDefaultNoCarousel = "slider-default-no_carousel",
  sliderRangeNoCarousel = "slider-range-no_carousel",
  squareIconButtonWithSliderAndBG = "square_icon_button_with_slider_and_bg",
  centerMeasurement = "center_meas",
  checkBox = "checkbox",
  checkBoxWithDropDown = "checkbox_with_dropdown",
  multiSelectCheckBoxWithDropDown = "multiselect_checkbox_with_dropdown",
  radioButton = "radio_button",
  radioButtonWithDropDown = "radio_button_with_dropdown",
  selectRadioButtonWithDropDown = "select_radio_button_with_dropdown",
}
